import QuizList from './QuizList';
import QuizCreate from './QuizCreate';
import QuizEdit from './QuizEdit';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const quizResource = {
  list: QuizList,
  create: QuizCreate,
  edit: QuizEdit,
  icon: () => <Icon><Box component="img" src='icons/quizzes.svg' /></Icon>,
};

export default quizResource;